var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"appear":"","enter-active-class":"animated bounceInRight"}},[_c('f7-view',{attrs:{"main":""}},[_c('f7-page',[_c('cm-navbar',{attrs:{"title":"Not found"}}),_c('f7-block',{attrs:{"strong":""}},[_c('p',[_vm._v("Sorry")]),_c('p',[_vm._v("Requested content not found.")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }